import { ChangeDetectorRef, Directive, EventEmitter, inject, OnInit, Output } from '@angular/core';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { combineLatest, filter } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ImmomioIcons } from '../../models/general/icon-name.type.generated';
import {
  contractStatusConverter,
  CustomerService,
  masterdataHelper,
  RouterService,
} from '../../services';
import { IMasterdataChangeConfiguration } from '../../models';
import {
  getContracts,
  getMasterDataChangeConfiguration,
  getMasterDataChangeConfigurationActionState,
  getPersonalData,
  getPersonalDataActionState,
  getTicketSettings,
  IMasterDataState,
  LoadMasterDataChangeConfiguration,
} from '../../+state';

@UntilDestroy()
@Directive()
export abstract class UserProfileCardBaseComponent implements OnInit {
  @Output() profileUpdate = new EventEmitter();
  protected routerService = inject(RouterService);
  protected store = inject(Store);
  protected customerService = inject(CustomerService);
  protected masterDataStore: Store<IMasterDataState> = inject(Store);
  private cdr = inject(ChangeDetectorRef);

  public user$ = this.store.select(getPersonalData);
  public userActionState$ = this.store.select(getPersonalDataActionState);
  public immomioIconName = ImmomioIcons;

  public showChangeButton = false;
  public masterDataChangeConfiguration: IMasterdataChangeConfiguration[] | null;

  protected constructor() {
    this.store.dispatch(LoadMasterDataChangeConfiguration());
  }

  ngOnInit(): void {
    this.userActionState$ = this.store.select(getPersonalDataActionState);
    this.store
      .select(getMasterDataChangeConfigurationActionState)
      .pipe(
        filter(state => state.done),
        switchMap(() =>
          combineLatest([
            this.store.select(getMasterDataChangeConfiguration),
            this.store.select(getContracts),
            this.store.select(getTicketSettings),
          ]).pipe(untilDestroyed(this))
        )
      )
      .subscribe(([masterDataChangeConfiguration, contracts, ticketSettings]) => {
        const activeContract =
          contracts?.length && contractStatusConverter.isAnyContractActive(contracts);
        const contractlessTicketCreation =
          ticketSettings?.allowContractlessTicketCreationForOtherConcerns ?? false;
        const disabledTicketManagement = this.customerService.hideTicketManagement();

        this.showChangeButton = masterdataHelper.checkShowChangeButton(
          masterDataChangeConfiguration,
          activeContract,
          contractlessTicketCreation,
          disabledTicketManagement
        );
        this.masterDataChangeConfiguration = masterDataChangeConfiguration;
        this.cdr.markForCheck();
      });
  }
}
